import React, { Component } from 'react';
import uuid from 'uuid';
import $ from 'jquery';
import csv2geojson from 'csv2geojson';
import kml2geojson from '@mapbox/togeojson';
import xml from 'xmldom';
import GeometryEdit from './GeometryEdit';
import { selectGeometry } from '../actions/actions_map';
import { changeMapData, changeZoom, changeCenter, changePitch, changeBearing, changeStyle, changePopupHTML, changeMapCategories } from '../actions/index';
// import $ from 'jquery';

const chance = require('chance').Chance();

class EditPanel extends Component {

  constructor(props) {
    super(props);
    this.setMapObject = this.setMapObject.bind(this)
    this.state = {
      savedHTML : this.props.mapObject.popupHTML,
      currentTab : 'marker',
      jsonFiles: [],
      createdFeaturesCounter: 1
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps.mapObject);
    if(nextProps.mapActions.selectGeometry) {
      var currentGeometry = false;
      nextProps.mapObject.mapData.forEach(function(feature) {
        if(feature.id===nextProps.mapActions.selectGeometry) {
          currentGeometry = feature;
        }
      });
      var tab = 'marker';
      if(currentGeometry) {
        if(currentGeometry.geometry.type==='Polygon') {
          tab = 'fill';
        }
        if(currentGeometry.geometry.type==='LineString') {
          tab = 'line';
        }
      }
      this.setState({currentTab:tab})
    }
  }

  setMapObject(option,e) {
    if(!e[0] && typeof e !== 'string'&&typeof e.hex === 'undefined'&&typeof e !== "boolean") {
      e.preventDefault();
    }
    switch (option) {
      case 'zoom':
        this.props.dispatch(changeZoom(e.target.value));
        break;
      case 'style':
        var newStyle = 'mapbox://styles/mapbox/streets-v10';
        if(e) {
          if(typeof e.target !== 'undefined') {
            newStyle = e.target.value;
          } else if(typeof e.value !== 'undefined') {
            newStyle = e.value;
          } else {
            newStyle = e;
          }
        }
        this.props.dispatch(changeStyle(newStyle));
        break;
      case 'center':
        var array = e.target.value.split(',');
        this.props.dispatch(changeCenter(array));
        break;
      case 'bearing':
        this.props.dispatch(changeBearing(e.target.value));
        break;
      case 'pitch':
        this.props.dispatch(changePitch(e.target.value));
        break;
      case 'popupHTML':
        this.props.dispatch(changePopupHTML(this.state.savedHTML));
        break;
      case 'popup_open':
        var newMapData = [];
        this.props.mapObject.mapData.forEach(function(feature) {
          var thisFeature = JSON.parse(JSON.stringify(feature));
          if(thisFeature.id===this.props.mapActions.selectGeometry) {
            thisFeature.properties['popup_open'] = !thisFeature.properties['popup_open'];
            newMapData.push(thisFeature);
          } else {
            newMapData.push(thisFeature);
          }
        }.bind(this))
        this.props.dispatch(changeMapData(newMapData));
        break;
      case 'marker_title':
        var newMapData = [];
        this.props.mapObject.mapData.forEach(function(feature) {
          var thisFeature = JSON.parse(JSON.stringify(feature));
          if(thisFeature.id===this.props.mapActions.selectGeometry) {
            thisFeature.properties['marker_title'] = e;
            newMapData.push(thisFeature);
          } else {
            newMapData.push(thisFeature);
          }
        }.bind(this))
        this.props.dispatch(changeMapData(newMapData));
        break;
      case 'markerIcon':
        // Here, this should change the geometry. property in the geoJSON for the image url for marker
        // Option is passed as an array
        var newMapData = [];
        // console.log(e);
        this.props.mapObject.mapData.forEach(function(feature) {
          var thisFeature = JSON.parse(JSON.stringify(feature));
          if(thisFeature.id===this.props.mapActions.selectGeometry) {
            thisFeature.properties['marker_icon_url'] = e[0];
          thisFeature.properties['marker_icon_anchor'] = e[1];
            newMapData.push(thisFeature);
          } else {
            newMapData.push(thisFeature);
          }
        }.bind(this))
        this.props.dispatch(changeMapData(newMapData));
        break;
      case 'color':
        var newMapData = [];
        this.props.mapObject.mapData.forEach(function(feature) {
          var thisFeature = JSON.parse(JSON.stringify(feature));
          if(thisFeature.id===this.props.mapActions.selectGeometry) {
            thisFeature.properties['color'] = e.hex;
            thisFeature.properties['opacity'] = e.rgb.a;
            thisFeature.properties['rgb'] = e.rgb;
            newMapData.push(thisFeature);
          } else {
            newMapData.push(thisFeature);
          }
        }.bind(this))
        this.props.dispatch(changeMapData(newMapData));
        break;
      case 'base_height':
        var newMapData = [];
        this.props.mapObject.mapData.forEach(function(feature) {
          var thisFeature = JSON.parse(JSON.stringify(feature));
          if (thisFeature.id===this.props.mapActions.selectGeometry) {
            thisFeature.properties.base_height = e;
            newMapData.push(thisFeature);
          } else {
            newMapData.push(thisFeature);
          }
        }.bind(this))
        this.props.dispatch(changeMapData(newMapData));
        break;
      case 'extrusion_height':
        var newMapData = [];
        this.props.mapObject.mapData.forEach(function(feature) {
          var thisFeature = JSON.parse(JSON.stringify(feature));
          if (thisFeature.id===this.props.mapActions.selectGeometry) {
            thisFeature.properties.height = e;
            newMapData.push(thisFeature);
          } else {
            newMapData.push(thisFeature);
          }
        }.bind(this))
        this.props.dispatch(changeMapData(newMapData));
        break;
      default:
        break;
    }
  }

  getFileType = (files) => {
    const fileType = files[0].type ? files[0].type : files[0].name.split('.')[files[0].name.split('.').length - 1];
    return fileType;
  }

  onDropHelper = (uploadedFile, fileType) => {
    let convertedFile;
    let { createdFeaturesCounter } = this.state;

    switch (fileType) {
      case 'application/json':
        convertedFile = JSON.parse(uploadedFile);
        break;

      case 'geojson':
        convertedFile = JSON.parse(uploadedFile);
        break;

      case 'text/csv':
        csv2geojson.csv2geojson(uploadedFile, (err, data) => {
          if (err) throw new Error(err.message);
          convertedFile = data;
        });
        break;

      case 'kml':
        const kml = new xml.DOMParser().parseFromString(uploadedFile);
        convertedFile = kml2geojson.kml(kml);
        break;

      default:
        alert('Valid file types include:\n.kml, .geojson, .json, .csv');
        throw new Error('Invalid file type');
      }

    if (convertedFile.features.length > 0) {
      convertedFile.features.forEach((f) => {
        const { name, description, marker_title, marker_icon_url, color } = f.properties;
        const default_marker_icon_url = $('#wp_mapbox_gl_js_plugin_url').val()+"/wp-mapbox-gl-js/admin/wp-mapmaker/public/img/black_default.png";

        // Don't overwrite data if it exists
        f.id                            = f.id ? f.id : uuid();
        f.properties.name               = name ? name : `Created Feature ${createdFeaturesCounter}`;
        f.properties.color              = color ? color : chance.color({ format: 'hex' });
        f.properties.popup_open         = true;
        f.properties.description        = description ? description : 'Description';
        f.properties.marker_title       = marker_title ? marker_title : '';
        f.properties.marker_icon_url    = marker_icon_url ? marker_icon_url : default_marker_icon_url;
        f.properties.marker_icon_anchor = 'bottom';

        switch (f.geometry.type) {
          case 'Polygon':
          case 'MultiPolygon':
            f.properties.name         = name ? name : 'Fill';
            f.properties.marker_title = marker_title ? marker_title : 'Fill';
            break;
          case 'LineString':
          case 'MultiLineString':
            f.properties.name         = name ? name : 'Line';
            f.properties.marker_title = marker_title ? marker_title : 'Line';
            break;
          case 'Point':
            f.properties.name         = name ? name : '';
            f.properties.color        = color ? color : '#333';
            f.properties.marker_title = marker_title ? marker_title : 'Marker';
            break;
          default:
            break;
        }

        createdFeaturesCounter++;
        this.setState({ createdFeaturesCounter });
    });
      return convertedFile.features;
    } else {
      alert('No features found.\nPlease check your file and try uploading again.');
      return;
    }
  }

  onDrop = (files, rejected) => {
    if (rejected.length > 0) throw new Error('Upload failed:', rejected);
    if (files.length > 1) {
      alert('Please upload one file at a time');
      throw new Error('Upload failed. Reason: Multiple files');
    }
    if (files[0].size === 0) {
      alert('The file you uploded seems to be empty.\nPlease check the file and try again.');
      throw new Error('Upload failed. Reason: Empty file');
    }

    const reader = new FileReader();
    const fileType = this.getFileType(files);

    reader.onload = (e) => {
      const { mapData } = this.props.mapObject;
      const newMapData = [].concat(mapData);

      this.onDropHelper(e.target.result, fileType).forEach((json) => {
        newMapData.push(json);

        const featureCollection = this.addToMbDrawHelper(json);
        this.props.Draw.add(featureCollection);
      });

      const lastGeometryUploaded = newMapData[newMapData.length - 1]
      this.props.dispatch(changeMapData(newMapData));
      this.props.dispatch(selectGeometry(lastGeometryUploaded.id));
    }

    files.forEach((file) => {
      reader.readAsText(file);
    });
  }

  addToMbDrawHelper = (feature) => {
    return {
        "type" : "FeatureCollection",
        "features" : [feature]
    }
  }

  render() {

    var currentGeometry = false;
    this.props.mapObject.mapData.forEach(function(feature) {
      if(feature.id===this.props.mapActions.selectGeometry) {
        currentGeometry = feature;
      }
    }.bind(this))

    return (
      <div className="wp-mapbox-gl-js-edit-panel">
        <div className="wp-mapbox-gl-js-tabs-left">
          <ul>
            <li className={this.state.currentTab==='marker' ? 'wp-mapbox-gl-js-active' : ''} onClick={ () => { this.setState({currentTab: 'marker'}); this.props.dispatch(selectGeometry(false)) }}>Markers</li>
            <li className={this.state.currentTab==='fill' ? 'wp-mapbox-gl-js-active' : ''} onClick={ () => { this.setState({currentTab: 'fill'}); this.props.dispatch(selectGeometry(false)) }}>Fills</li>
            <li className={this.state.currentTab==='line' ? 'wp-mapbox-gl-js-active' : ''} onClick={ () => { this.setState({currentTab: 'line'}); this.props.dispatch(selectGeometry(false)) }}>Lines</li>
            <li className={this.state.currentTab==='upload' ? 'wp-mapbox-gl-js-active' : ''} onClick={ () => { this.setState({currentTab: 'upload'}); this.props.dispatch(selectGeometry(false)) }}>Import/Export</li>
          </ul>
        </div>
        <div className="wp-mapbox-gl-js-tabs-right">
          <GeometryEdit
            type={this.state.currentTab}
            selectGeometry={selectGeometry}
            currentGeometry={currentGeometry}
            setMapObject={this.setMapObject}
            addToMbDrawHelper={this.addToMbDrawHelper}
            onDrop={this.onDrop}
            {...this.props} />
        </div>
      </div>
    );
  }
}

export default EditPanel;



// WEBPACK FOOTER //
// ./src/components/EditPanel.js